// extracted by mini-css-extract-plugin
export var light = "Partners-module--light--0a7c5";
export var dark = "Partners-module--dark--59318";
export var layout = "Partners-module--layout--34eef";
export var horizontal = "Partners-module--horizontal--6809e";
export var header = "Partners-module--header--cbec9";
export var sliderWrapper = "Partners-module--sliderWrapper--90603";
export var description = "Partners-module--description--7aafc";
export var slide = "Partners-module--slide--c379d";